import { Redirect, useGlobalSearchParams } from 'expo-router';
import { useLeagueContext } from '@/contexts/LeagueContext';
import LeaguePicksRoute from '../picks_content';
import NativeTabFocusGate from '@/components/navigation/NativeTabFocusGate';
import { getLandingHref, getLeagueHref } from '@/lib/routes';

export default function LeaguePicksWrapper() {
  const routeParams = useGlobalSearchParams<{
    season?: string | string[];
    week?: string | string[];
  }>();
  const context = useLeagueContext();
  const id = context.id;

  if (!id || id === 'undefined') {
    return <Redirect href={getLandingHref()} />;
  }

  if (context.isMarchMadness) {
    const seasonParam = Array.isArray(routeParams.season) ? routeParams.season[0] : routeParams.season;
    const weekParam = Array.isArray(routeParams.week) ? routeParams.week[0] : routeParams.week;

    return (
      <Redirect
        href={getLeagueHref(id, 'draft', {
          seasonId: seasonParam ?? null,
          weekId: weekParam ?? null,
        })}
      />
    );
  }

  return (
    <NativeTabFocusGate>
      <LeaguePicksRoute />
    </NativeTabFocusGate>
  );
}
